/**
 * Logo component
 * 
 */

import React, { PureComponent } from 'react';
import { Link, withRouter } from 'react-router-dom';

// Javascript

import DrawerJs from '../../assets/js/drawer';
import Event from '../../utils/functions/analytics';

class Logo extends PureComponent {

	constructor(props) {

		super(props);
		
    	this.handleClick = this.handleClick.bind(this);
	}

	handleClick(event) {

		event.preventDefault();

		const target = event.currentTarget.getAttribute('href');
		const navigate = () => { this.props.history.push(target); }

		if (document.body.classList.contains('drawer-visible')) {

			const toggle = document.body.getAttribute('data-toggle');
			const panel = document.getElementById(toggle);

			setTimeout(() => { DrawerJs.transition(panel, 'close', navigate) }, 100);
		}
		else {

			navigate();
		}

		Event.navigation({ action: 'logo', label: event.target.text });
	}

	render() {

		const { url, alt, dimensions } = this.props.data;
		
		return <div className="logo"><Link to="/" onClick={this.handleClick}><img src={url} width={dimensions.width} height={dimensions.height} alt={alt} /></Link></div>;
	}
}

export default withRouter(Logo)



// WEBPACK FOOTER //
// ./src/components/logo/logo.js